const List = () => import('@/views/main/voice/list/List.vue')
export default {
  path: '/main/voice/list',
  name: 'List',
  component: List,
  children: []
}
